'use client';

import { CardVariants, ConfigUrlData } from '@/app/lib/schemas/types/app-types';
import CardFooterDefaultContainer from './card-footer-default-container';
import CardFooterFeaturedContainer from './card-footer-featured-container';
import { configPathToSolutionPage } from '@/app/lib/utils/helpers';
import { useRouter } from 'next/navigation';
import { useAppSelector } from '@/app/lib/store/hooks';
import { useEffect, useState } from 'react';

interface Props {
  markdown: string;
  variant: CardVariants;
  configUrlData: ConfigUrlData;
}

const CardFooterContainer = ({ markdown, configUrlData, variant }: Props) => {
  const router = useRouter();
  const scrollPosition = useAppSelector(state => state.scroll.scrollTop);

  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  const handleShowSolution = (baseUrl: string) => {
    const pathToSolution = configPathToSolutionPage(
      baseUrl,
      configUrlData.difficulty,
      configUrlData.id
    );

    sessionStorage.setItem('scrollPosition', String(scrollPosition));
    sessionStorage.setItem('prevPage', window.location.pathname);
    router.push(pathToSolution);
  };

  if (!isClient) return null;

  return (
    <>
      {variant === 'default' ? (
        <CardFooterDefaultContainer
          markdown={markdown}
          onShowSolution={handleShowSolution}
        />
      ) : (
        <CardFooterFeaturedContainer
          markdown={markdown}
          onShowSolution={handleShowSolution}
          configUrlData={configUrlData}
        />
      )}
    </>
  );
};

export default CardFooterContainer;
